<style scoped lang="stylus" rel="stylesheet/stylus"></style>

<template>
	<ul>
		<li v-for="(todo, index) in filteredTodos" :key="index">
			<slot name="todo" :todo="todo">
				{{ todo.text }}
			</slot>
		</li>
	</ul>
</template>

<script>
export default {
	name: 'navigationLink1',
	components: {},
	props: {
		url: String
	},
	data() {
		return {
			filteredTodos: [
				{
					text: '游泳',
					time: '30min',
					id: 'yy'
				},
				{
					text: '跑步',
					time: '20min',
					id: 'pb'
				},
				{
					text: '读书',
					time: '1h',
					id: 'ds'
				}
			]
		}
	}
}
</script>
